var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "generic--template page-template pb5 bg-beige" },
          [
            _c("div", { staticClass: "relative z-content" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw8-5 center" },
                [
                  _c("div", { staticClass: "row mt3 mt4-ns" }, [
                    _c("div", { staticClass: "dn db-ns col-xs-12 col-sm-6" }, [
                      _c("div", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy:background",
                            value: _vm.page.hero_image,
                            expression: "page.hero_image",
                            arg: "background",
                          },
                        ],
                        staticClass:
                          "db relative aspect-ratio--16x9 bg-teal center cover",
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                      _c(
                        "div",
                        {
                          staticClass: "db relative aspect-ratio--16x9 bg-teal",
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "lazy",
                                rawName: "v-lazy",
                                value: _vm.page.logo,
                                expression: "page.logo",
                              },
                            ],
                            staticClass:
                              "db absolute abs-vert-center left-0 right-0 center mw-24rem",
                            attrs: { title: "Outside Lands Works" },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "db dn-ns col-xs-12 col-sm-6" }, [
                      _c("div", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy:background",
                            value: _vm.page.hero_image,
                            expression: "page.hero_image",
                            arg: "background",
                          },
                        ],
                        staticClass:
                          "db relative aspect-ratio--16x9 bg-teal center cover",
                      }),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("section", { staticClass: "relative" }, [
                _c(
                  "div",
                  { staticClass: "relative container-fluid mw8-5 center" },
                  [
                    _c("div", { staticClass: "row center" }, [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12 mt4 mt5-ns" },
                        [
                          _vm.page.intro_text
                            ? _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 col-sm-12 pb3" },
                                  [
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f2 mb4 tl is-tablet-bold is-teal",
                                      },
                                      [_vm._v("About Outside Lands Works")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "f4 is-tablet-regular link-bold lh-copy cms-content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.marked(_vm.page.intro_text)
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-xs-12 col-sm-12 pb5" },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "f2 pb4 mb3 is-tablet-bold is-teal",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.page.grantees_section.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  _vm._l(
                                    _vm.page.grantees_section.grantees,
                                    function (grantee, index) {
                                      return _c(
                                        "a",
                                        {
                                          key: "grantee-item-" + index,
                                          staticClass: "col-xs-12 col-sm-6 mb3",
                                          attrs: {
                                            href: grantee.link,
                                            target: "_blank",
                                            title: grantee.title,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-row items-center",
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "db relative center mw4",
                                                attrs: {
                                                  src: grantee.image,
                                                  title: grantee.title,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "f4 mv3 pl3 lh-copy is-black",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      grantee.text
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        grantee.text
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "mt3 ttu is-black",
                                                    },
                                                    [_vm._v("Learn More")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "db relative center mw8 pt5 pt6-ns",
                  attrs: { id: "ol-works" },
                },
                [
                  _c("div", {
                    staticClass: "plg-donate",
                    attrs: { "data-widget-id": "xsZJ7T2BtWPZdsf0VZa1tg" },
                  }),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }